import React from 'react'
// import { Route, Switch } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import FacilityDirectory from '../pages/FacilityDirectory/FacilityDirectory'
import FacilityProfile from '../pages/FacilityProfile'
import ProviderDirectory from '../pages/ProviderDirectory/ProviderDirectory'
import ProviderProfile from '../pages/ProviderProfile'
import routes from './paths'
import FindCare from '../pages/FindCare'
import NotFound from '../pages/NotFound'

// these pages are no longer needed. keeping for reference for now

// import CareDoctors from '../pages/Care/CareDoctors'
// import CareFacilities from '../pages/Care/CareFacilities/CareFacilities'
// import CareSpecialties from '../pages/Care/CareSpecialties'

export const Router = () => {
  return (
    <Switch>
      <Route path={routes.providerProfile} component={ProviderProfile} />
      <Route path={routes.providersDirectory} component={ProviderDirectory} />
      <Route path={routes.facilityProfile} component={FacilityProfile} />
      <Route path={routes.facilitiesDirectory} component={FacilityDirectory} />
      <Route path={routes.facilitiesDirectory} component={FacilityDirectory} />
      {/* <Route path={routes.careDoctors} component={CareDoctors} />
      <Route path={routes.careSpecialties} component={CareSpecialties} />
      <Route path={routes.careFacilities} component={CareFacilities} /> */}
      <Route path={routes.care} component={FindCare} />
      <Redirect path="/" exact to={routes.care} />
      <Route component={NotFound} />
    </Switch>
  )
}
